import { render, staticRenderFns } from "./SalaryIcon.vue?vue&type=template&id=6ee75a6a&"
import script from "./SalaryIcon.vue?vue&type=script&lang=js&"
export * from "./SalaryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports